import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { BaseService } from "../base.service";
import * as _ from 'lodash'; 
import { Observable } from "rxjs";
import { RecaptchaRequest } from "../../shared/recaptcha-request";
import { AppConsts } from "@shared/app-consts";


const grecaptchaObject = window["grecaptcha"];
if(grecaptchaObject) grecaptchaObject.ready(() => {
  window["grecaptcha-isready"] = true;
});
const callBackRecaptcha =() => {
  //empty callback
 }
@Injectable()
export class RecaptchaService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  checkRecaptcha(model: RecaptchaRequest): Observable<any> {
    let httpOptions = this.getHttpHeader();
    return this.http.post(environment.API_SERVICE_URL + "Recpatcha/verify", model, httpOptions);
  }

  static submitWithCaptcha = (actionSubmit: any,event : any, actionName : string) => {
    if(window["grecaptcha-isready"]){
      grecaptchaObject.execute(AppConsts.RECAPTCHA_SITE_KEY, { action: actionName })
      .then((token) => {
        actionSubmit(event,token);
      });
    }
  }
  static initGRecaptcha = () => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
      if (!isScriptExist) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
      if (isScriptExist && callback) callback();
    };
    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${AppConsts.RECAPTCHA_SITE_KEY}`,
      callBackRecaptcha
    );
  };

}
